import type { IRecentlyViewedEntry } from "./getRecentlyViewedPages.schema";

export const RECENTLY_VIEWED_PAGES_MAX_ENTRIES = 10;

const getLastVisitedAtMs = (entry: IRecentlyViewedEntry): number => {
  const timestamp = Date.parse(entry.lastVisitedAt);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const mergeRecentlyViewedEntries = ({
  existingEntries,
  incomingEntries,
}: {
  readonly existingEntries: IRecentlyViewedEntry[];
  readonly incomingEntries: IRecentlyViewedEntry[];
}): IRecentlyViewedEntry[] => {
  const byPath = new Map<string, IRecentlyViewedEntry>();

  for (const entry of [...existingEntries, ...incomingEntries]) {
    const previous = byPath.get(entry.path);
    if (
      !previous ||
      getLastVisitedAtMs(entry) >= getLastVisitedAtMs(previous)
    ) {
      byPath.set(entry.path, entry);
    }
  }

  return [...byPath.values()]
    .sort((a, b) => getLastVisitedAtMs(b) - getLastVisitedAtMs(a))
    .slice(0, RECENTLY_VIEWED_PAGES_MAX_ENTRIES);
};
